import { Formik, Form, Field } from "formik";
import { FormModel } from "../types/FormTypes";
import { useAtom } from "jotai";
import { formDataAtom } from "../App";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import Box from "../components/Box/Box";
import Progressbar from "../components/Progressbar/Progressbar";
import ErrorList from "../components/Form/ErrorList";
import { useRef } from "react";
import { handleSubmitClick } from "../components/Form/FormUtils";
import BackButton from "../components/Buttons/BackButton";
import useFocusOnLoad from "../hooks/useFocusOnLoad";

export const COMPENSATION_TICKET = "compensation_ticket";
export const COMPENSATION_TAXI = "compensation_taxi";
export const COMPENSATION_CAR = "compensation_car";

export default function Compensation() {
    const h2Ref = useFocusOnLoad<HTMLHeadingElement>();
    const [formData, setFormData] = useAtom(formDataAtom);
    const navigate = useNavigate();
    const formRef = useRef<HTMLFormElement>(null);

    return (
        <div>
            <Formik<FormModel>
                onSubmit={(values) => {
                    setFormData({
                        ...formData,
                        ...values,
                    });

                    if (values.compensation === COMPENSATION_TICKET) {
                        navigate("/hur-vill-du-ha-ersattning");
                    } else if (values.compensation === COMPENSATION_TAXI) {
                        navigate("/ersattning-for-taxi");
                    } else if (values.compensation === COMPENSATION_CAR) {
                        navigate("/ersattning-for-bil");
                    }

                }}
                initialValues={{
                    ...formData,
                }}
                enableReinitialize
                validateOnChange={false}
                validateOnBlur={false}
                validationSchema={Yup.object().shape({
                    compensation: Yup.string().test(
                        "at-least-one-radio-selected",
                        "Vänligen välj ett svarsalternativ för att gå vidare till nästa steg",
                        (value) => {
                            return value === COMPENSATION_TICKET ||
                                value === COMPENSATION_TAXI ||
                                value === COMPENSATION_CAR;
                        }
                    ),
                })}
            >
                {({ errors, values }) => (
                    <>
                        <div className="flex justify-end items-center">
                            <div className="xs:w-52 md:w-full max-w-xs">
                                <Progressbar percentage={"50"} />
                            </div>
                        </div>
                        <Form noValidate>
                            <Box>
                                <h2 ref={h2Ref} tabIndex={-1} id="compensation">
                                    Vad önskar du ha ersättning för?
                                </h2>

                                {Object.keys(errors).length > 0 && <ErrorList errors={errors} />}

                                <div
                                    role="radiogroup"
                                    aria-labelledby="compensation"
                                    className="radio-group"
                                >
                                    {errors.compensation && (
                                        <span
                                            aria-describedby="forMe forOther"
                                            className="validation-error"
                                        >
                                            {errors.compensation.toString()}
                                        </span>
                                    )}

                                    <div className={errors.compensation ? "has-error" : ""}>
                                        <Field
                                            id="compensationTicket"
                                            type="radio"
                                            name="compensation"
                                            value={COMPENSATION_TICKET}
                                            checked={values.compensation === COMPENSATION_TICKET}
                                        />
                                        <label htmlFor="compensationTicket">Jag vill ha ersättning av priset för en enkelbiljett</label>
                                    </div>

                                    <div className={errors.compensation ? "has-error" : ""}>
                                        <Field
                                            id="compensationTaxi"
                                            type="radio"
                                            name="compensation"
                                            value={COMPENSATION_TAXI}
                                            checked={values.compensation === COMPENSATION_TAXI}
                                        />
                                        <label htmlFor="compensationTaxi">Jag vill ha ersättning för resa med taxi</label>
                                    </div>

                                    <div className={errors.compensation ? "has-error" : ""}>
                                        <Field
                                            id="compensationCar"
                                            type="radio"
                                            name="compensation"
                                            value={COMPENSATION_CAR}
                                            checked={values.compensation === COMPENSATION_CAR}
                                        />
                                        <label htmlFor="compensationCar">Jag vill ha ersättning för resa med bil </label>
                                    </div>

                                </div>
                            </Box>

                            <div className="flex justify-center">
                                <div className="w-full text-left flex items-center">
                                    <BackButton />
                                </div>
                                <div className="w-full text-right">
                                    <button
                                        onClick={handleSubmitClick(formRef)}
                                        className="btn primary"
                                        type="submit"
                                    >
                                        Gå vidare
                                    </button>
                                </div>
                            </div>

                        </Form>
                    </>
                )}
            </Formik>
        </div>
    );
}
